import { Button } from "primereact/button";
import { Tag } from "primereact/tag";

import { Accordion, AccordionTab, Icon } from "@/ds";

import {
  PAPEIS_OBRIGATORIOS_ADD_LABEL,
  PAPEIS_OBRIGATORIOS_ADDED_LABEL,
  PAPEIS_OBRIGATORIOS_EMPTY,
  PAPEIS_OBRIGATORIOS_HINT,
  PAPEIS_OBRIGATORIOS_TITLE,
} from "./papeis-obrigatorios.constants";
import styles from "./papeis-obrigatorios.module.scss";
import type { PapeisObrigatoriosViewModel } from "./types-papeis-obrigatorios";

const CHEVRON_ABERTO = () => <Icon name="chevron-down" size={14} />;
const CHEVRON_RECOLHIDO = () => <Icon name="chevron-right" size={14} />;

/**
 * "Papéis Obrigatórios" (Figma 12227:422530 recolhido, 9142:688240 aberto): seção recolhível sobre o `Accordion` do DS, com
 * cada papel, o prazo (D-n) e a ação Adicionar, ou a tag Adicionado quando já está na equipe.
 */
export function PapeisObrigatoriosView(vm: PapeisObrigatoriosViewModel) {
  return (
    <Accordion
      className={`p-accordion-card ${styles.secao}`}
      activeIndex={vm.aberto ? 0 : null}
      onTabChange={vm.alternar}
      collapseIcon={CHEVRON_ABERTO}
      expandIcon={CHEVRON_RECOLHIDO}
      data-open={vm.aberto || undefined}
      data-testid="equipe-obra-required"
    >
      <AccordionTab
        headerTemplate={<span className={styles.titulo}>{PAPEIS_OBRIGATORIOS_TITLE}</span>}
        pt={{
          header: { className: styles.cabecalho },
          headerAction: { "data-testid": "equipe-obra-required-toggle" },
        }}
      >
        {vm.aberto ? (
          <div className={styles.corpo}>
            <p className={styles.dica}>{PAPEIS_OBRIGATORIOS_HINT}</p>

            {vm.textoCarregando ? (
              <span className={styles.vazio} data-testid="equipe-obra-loading">
                {vm.textoCarregando}
              </span>
            ) : null}

            {vm.mostrarVazio ? (
              <span className={styles.vazio}>{PAPEIS_OBRIGATORIOS_EMPTY}</span>
            ) : null}

            <ul className={styles.lista}>
              {vm.itens.map((papel) => (
                <li key={papel.id} className={styles.papel} data-testid={papel.testId}>
                  <div className={styles.info}>
                    <div className={styles.nomePrazo}>
                      <span className={styles.nome}>{papel.nome}</span>
                      {papel.prazo ? <Tag severity="warning" value={papel.prazo} /> : null}
                    </div>
                    {papel.mensagemVencido ? (
                      <span className={styles.vencido} role="alert">
                        {papel.mensagemVencido}
                      </span>
                    ) : null}
                  </div>
                  {papel.adicionado ? (
                    <Tag
                      severity="success"
                      value={PAPEIS_OBRIGATORIOS_ADDED_LABEL}
                      data-testid={papel.adicionadoTestId}
                    />
                  ) : null}
                  {papel.mostrarAdicionar ? (
                    <Button
                      type="button"
                      size="small"
                      severity="secondary"
                      outlined
                      label={PAPEIS_OBRIGATORIOS_ADD_LABEL}
                      aria-label={papel.adicionarLabel}
                      disabled={vm.adicionarDesabilitado}
                      onClick={papel.adicionar}
                      data-testid={papel.adicionarTestId}
                    />
                  ) : null}
                </li>
              ))}
            </ul>
          </div>
        ) : null}
      </AccordionTab>
    </Accordion>
  );
}
